module.exports = __webpack_public_path__ + "static/img/1.b2b2e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/1.jpg
// module id = 4xmP
// module chunks = 1